import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHead } from "@/lib/motion";

const FAQS = [
  {
    q: "Quelle est la différence entre l'assistance et le logiciel seul ?",
    a: "Avec l'assistance, un expert RH et un expert paie de KORBAN CONSULTING prennent en charge la gestion externe de votre paie et de vos ressources humaines (forfaits de 50 000 à 100 000 FCFA/mois selon votre taille). Avec le logiciel seul (25 000 ou 35 000 FCFA/mois), vous utilisez uniquement la plateforme Boussole de la Paie (SIRH-CI/PAIE), sans cette prise en charge.",
  },
  {
    q: "Que comprend l'assistance en gestion externe de la paie et des RH ?",
    a: "L'établissement des bulletins de paie, les déclarations sociales (CNPS) et fiscales, les contrats de travail et les formalités d'embauche et de départ, l'administration et les dossiers du personnel, le suivi des congés, des absences et des présences, ainsi que le conseil en conformité avec la réglementation du travail.",
  },
  {
    q: "Puis-je commencer avec le logiciel seul puis passer à l'assistance complète ?",
    a: "Oui. Contactez-nous à tout moment : nous faisons évoluer votre offre vers le forfait d'assistance adapté à la taille de votre entreprise.",
  },
  {
    q: "Les formations certifiantes sont-elles incluses dans ces tarifs ?",
    a: "Non : les formations certifiantes sont proposées séparément, avec des tarifs propres aux étudiants et aux salariés. Consultez la section « Formations » pour le détail de chaque parcours.",
  },
  {
    q: "Mon entreprise compte plus de 35 employés, que faire ?",
    a: "Contactez-nous au 07 69 54 54 69 ou via le formulaire de contact : nous vous proposons une offre adaptée à votre taille.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="border-t border-white/10 py-20 md:py-24" data-testid="section-faq">
      <div className="mx-auto max-w-3xl px-5">
        <SectionHead
          tag="Foire aux questions"
          title="Assistance ou logiciel seul : on vous éclaire."
        />
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`faq-${i}`} className="border-white/10">
              <AccordionTrigger
                data-testid={`faq-trigger-${i + 1}`}
                className="text-left font-display text-[1.05rem] font-semibold text-white hover:no-underline hover:text-korban-gold"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[0.95rem] leading-relaxed text-slate-300">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
